export const API_URL = process.env.REACT_APP_BACKEND_URL || '';

export const getAuthHeaders = () => {
  const token = localStorage.getItem('session_token');
  return token ? { 'Authorization': `Bearer ${token}` } : {};
};
